import { render, staticRenderFns } from "./StakeList.vue?vue&type=template&id=aaafed4c&scoped=true&"
import script from "./StakeList.vue?vue&type=script&lang=js&"
export * from "./StakeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaafed4c",
  null
  
)

export default component.exports